import { Injectable } from '@angular/core';
import { OCPPService } from './ocpp.service';
import { HttpClient } from '@angular/common/http';
import { ChangeAvailabilityRequest } from '../models/ChangeAvailabilityRequest';
import { ChangeConfigurationRequest } from '../models/ChangeConfigurationRequest';
import { ClearCacheRequest } from '../models/ClearCacheRequest';
import { DataTransferRequest } from '../models/DataTransferRequest';
import { GetConfigurationRequest } from '../models/GetConfigurationRequest';
import { RemoteStartTransactionRequest } from '../models/RemoteStartTransactionRequest';
import { RemoteStopTransactionRequest } from '../models/RemoteStopTransactionRequest';
import { UnlockConnectorRequest } from '../models/UnlockConnectorRequest';
import { ResetRequest } from '../models/ResetRequest';

@Injectable()
export class CoreService extends OCPPService {

    private CHANGE_AVAILABILITY_ENDPOINT = '/change-availability';
    private CHANGE_CONFIGURATION_ENDPOINT = '/change-configuration';
    private CLEAR_CACHE_ENDPOINT = '/clear-cache';
    private DATA_TRANSFER_ENDPOINT = '/data-transfer';
    private GET_CONFIGURATION_ENDPOINT = '/get-configuration';
    private REMOTE_START_TRANSACTION_ENDPOINT = '/remote-start-transaction';
    private REMOTE_STOP_TRANSACTION_ENDPOINT = '/remote-stop-transaction';
    private UNLOCK_CONNECTOR_ENDPOINT = '/unlock-connector';
    private RESET_ENDPOINT = '/reset';

    getProfileBasePath(): string {
        return '/operations/core';
    }

    constructor(private http: HttpClient) {
        super();
    }

    public changeAvailability(payload: ChangeAvailabilityRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.CHANGE_AVAILABILITY_ENDPOINT, payload);
    }

    public changeConfiguration(payload: ChangeConfigurationRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.CHANGE_CONFIGURATION_ENDPOINT, payload);
    }

    public clearCache(payload: ClearCacheRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.CLEAR_CACHE_ENDPOINT, payload);
    }

    public dataTransfer(payload: DataTransferRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.DATA_TRANSFER_ENDPOINT, payload);
    }

    public getConfiguration(payload: GetConfigurationRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.GET_CONFIGURATION_ENDPOINT, payload);
    }

    public remoteStartTransaction(payload: RemoteStartTransactionRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.REMOTE_START_TRANSACTION_ENDPOINT, payload);
    }

    public remoteStopTransaction(payload: RemoteStopTransactionRequest): any {
        return this.http.post(this.BASE_PATH + `/charging/stop?transactionId=${payload.transaction_d}`, '');
    }

    public unlockConnector(payload: UnlockConnectorRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.UNLOCK_CONNECTOR_ENDPOINT, payload);
    }

    public reset(payload: ResetRequest): any {
        return this.http.post(this.BASE_PATH + this.getProfileBasePath() + this.RESET_ENDPOINT, payload);
    }

}
